module.exports = __webpack_public_path__ + "assets/new-instagram.0e643035.svg";